module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_1.2dc84a63.png";